import * as React from "react";
import {WellnessConceptsLogo} from "../../components/widgets/WellnessConceptsLogo";
import {UIStateVendor} from "../../data/UIStateVendor";

import './VendorWrapper.pcss';

interface Props {
  children:any;
}

export const VendorWrapper = (props:Props) =>
    <div className={'vendor-wrapper'}>
      <div className="vendor-wrapper-logo" aria-hidden={true}><WellnessConceptsLogo /></div>
      <h1 className={'level1'}>{UIStateVendor.settings.COMPANY_NAME} <span style={{fontWeight:'normal'}}>vendor access</span></h1>
      <div className={"vendor-wrapper-content"}>
        {props.children}
      </div>
    </div>
;


